import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const STATUS_LABELS = {
  pending: 'Yapılmadı',
  informed: 'Arandı',
  completed: 'Yapıldı',
  reschedule: 'Tarih Değiştir',
};

export default function StatusConfirmModal({ targetStatus, onConfirm, onCancel }) {
  const label = STATUS_LABELS[targetStatus] || targetStatus;

  return (
    <div className="fixed inset-x-0 top-0 bottom-[65px] z-[99999] flex items-center justify-center p-4 sm:inset-0" data-testid="status-confirm-modal">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative bg-white sm:rounded-2xl shadow-2xl w-full sm:max-w-md lg:max-w-3xl sm:max-h-[75vh] overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <AlertTriangle size={18} className="text-orange-500" />
            <h3 className="text-sm font-bold text-gray-900">Durum Değişikliği</h3>
          </div>
          <button onClick={onCancel} className="p-1 rounded-lg hover:bg-gray-100" data-testid="confirm-modal-close">
            <X size={16} className="text-gray-500" />
          </button>
        </div>
        <div className="px-5 py-4">
          <p className="text-sm text-gray-700">
            İşlem <strong>"{label}"</strong> durumuna alınacak ve daha önce kaydedilen işlem kayıtları silinecek.
          </p>
          <p className="text-xs text-[#8E8E93] mt-2">Bu işlem geri alınamaz.</p>
        </div>
        <div className="flex gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50/50 rounded-b-2xl">
          <button
            onClick={onCancel}
            className="flex-1 px-3 py-2 text-xs font-semibold text-gray-600 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            data-testid="confirm-cancel-btn"
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-3 py-2 text-xs font-semibold text-white bg-orange-500 rounded-lg hover:bg-orange-600 transition-colors"
            data-testid="confirm-ok-btn"
          >
            Onayla
          </button>
        </div>
      </div>
    </div>
  );
}
